var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFargerike = function SvgFargerike(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.00000055 27.9999h7.57806055l5.02194-5.0573v-7.5427h-12.6z",
    fill: "#8cb91e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.4004 27.9999h7.5781l5.0219-5.0612v-7.5388h-12.6z",
    fill: "#e1aa00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28.0004 0v7.57806l-5.0549 5.02194h-7.5451v-12.6z",
    fill: "#d26e32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.6 0v7.57806l-5.05728 5.02194h-7.54272v-12.6z",
    fill: "#735fc3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFargerike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fargerike.4e8e1a031db8ccb026ec32887e65de58.svg";